<template>
  <el-dialog
    :model-value="modelValue"
    :title="title"
    :width="width"
    append-to-body
    destroy-on-close
    @update:model-value="emit('update:modelValue', $event)"
  >
    <MaterialListDisplay
      v-model:selected-ids="selectedIds"
      :channel-key="channelKey"
      :material-type="materialType"
      :account-id="numAccountId"
      selection-mode="single"
      @change="onItemChange"
    />
    <template #footer>
      <el-button @click="emit('update:modelValue', false)">取消</el-button>
      <el-button type="primary" :disabled="!selectedItem" @click="onConfirm">确认</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import MaterialListDisplay from '@/components/materialList/MaterialListDisplay.vue';
import type { ChannelMaterialItem, ChannelMaterialType } from '@/types/channelMaterials';

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    channelKey: string;
    materialType: ChannelMaterialType;
    accountId?: string;
    title?: string;
    width?: string;
  }>(),
  {
    accountId: undefined,
    title: '选择素材',
    width: '700px',
  },
);

const emit = defineEmits<{
  (e: 'update:modelValue', val: boolean): void;
  (e: 'confirm', card: Record<string, unknown>): void;
}>();

const numAccountId = computed(() => Number(props.accountId ?? 0));
const selectedIds = ref<(number | string)[]>([]);
const selectedItem = ref<ChannelMaterialItem | null>(null);

watch(
  () => props.modelValue,
  (val) => {
    if (val) {
      selectedIds.value = [];
      selectedItem.value = null;
    }
  },
);

const onItemChange = (items: ChannelMaterialItem[]) => {
  selectedItem.value = items[0] ?? null;
};

function onConfirm() {
  if (!selectedItem.value) return;
  emit('confirm', selectedItem.value as Record<string, unknown>);
  emit('update:modelValue', false);
}
</script>
